import { getNavigationUrls } from '../../../config/navigation'

export function redirectToPortal(path: string, locale: string) {
  const portalUrl = getNavigationUrls().portal
  globalThis.location.href = `${portalUrl}/${locale}/${path}`
}
